import { Button } from '@mui/material';
import { useFormik } from 'formik';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getBlogCategoryFn, getBlogSubCategoryByIdFn, patchBlogSubCategoryFn, postBlogSubCategoryFn } from 'Services/Blog';
import CustomInput from 'Shared/CustomInput';
import ImageInput from 'Shared/ImageInput';
import SelectInput from 'Shared/SelectInput';

const AddUpdateBlogSubCategory = () => {
    const [options, setOptions] = useState([]);
    const navigate = useNavigate();
    const { id, status } = useParams();

    const { data: responseCategory } = useQuery({
        queryKey: ['get-category'],
        queryFn: getBlogCategoryFn,
        onSuccess: (response) => {
            const category = responseCategory?.data?.data;
            const options = category.map((item) => ({ label: item?.name, value: item?.id }));
            setOptions(options);
        }
    })

    const { data: response } = useQuery({
        queryKey: ['get-sub-category-by-id', id, status],
        queryFn: () => getBlogSubCategoryByIdFn(id),
        enabled: !!id && status === "update"
    })
    const data = response?.data?.data[0] || {};

    const { mutate: post } = useMutation(postBlogSubCategoryFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/blog/sub-category')
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    })

    const { mutate: patch } = useMutation(patchBlogSubCategoryFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/blog/sub-category')
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    })

    const initialValues = {
        category: data?.category || "",
        image: "",
        name: data?.name || "",
    }

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {
            if (!values.name) return toast.error("Name is required.")
            if (!values.category) return toast.error("Category is required.")

            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('category', values.category);

            if (status === 'add') {
                if (!values.image) return toast.error("Image is required.")
                formData.append('image', values.image);
                post(formData);
            } else {
                if (values.image) formData.append('image', values.image);
                formData.append("blog_subcategory_id", id);
                patch(formData);
            }
        }
    });

    return (
        <div>
            <form
                className="w-[500px] bg-white shadow-md rounded-lg mx-auto p-4 flex flex-col gap-6"
                onSubmit={formik.handleSubmit}
            >
                <p className="text-xl !text-black font font-bold text-center">
                    {status === "update" ? "Update" : "Add"} Sub Category
                </p>
                <CustomInput formik={formik} label={"Name"} name={"name"} />
                <SelectInput formik={formik} label={"Category"} name={"category"} options={options} />
                <ImageInput formik={formik} label={"Image"} name={"image"} />
                <Button
                    type='submit'
                    variant='contained'
                >
                    {status === "update" ? "Update" : "Add"}
                </Button>
            </form>
        </div>
    )
}

export default AddUpdateBlogSubCategory;